/** Order status presentation + the commerce ladder (moved out of OrdersPage
 * unchanged — SA-397). */
import { Package, Clock, DollarSign, CheckCircle, XCircle, Truck, ChefHat } from 'lucide-react'
import type { OrderStatus } from '@/types/commerce'

export const STATUS_CONFIG: Record<OrderStatus, { label: string; color: string; dot: string; icon: typeof Package }> = {
  draft: { label: 'Draft', color: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground', icon: Package },
  pending_quote: { label: 'Pending Quote', color: 'bg-warning/10 text-warning-strong', dot: 'bg-warning', icon: Clock },
  quoted: { label: 'Quoted', color: 'bg-info/10 text-info', dot: 'bg-info', icon: DollarSign },
  pending_payment: { label: 'Pending Payment', color: 'bg-accent-orange/10 text-accent-orange', dot: 'bg-accent-orange', icon: DollarSign },
  deposit_paid: { label: 'Deposit Paid', color: 'bg-accent-indigo/10 text-accent-indigo', dot: 'bg-accent-indigo', icon: DollarSign },
  fully_paid: { label: 'Fully Paid', color: 'bg-success/10 text-success', dot: 'bg-success', icon: CheckCircle },
  in_production: { label: 'In Production', color: 'bg-accent-purple/10 text-accent-purple', dot: 'bg-accent-purple', icon: ChefHat },
  ready: { label: 'Ready', color: 'bg-accent-teal/10 text-accent-teal', dot: 'bg-accent-teal', icon: Truck },
  delivered: { label: 'Delivered', color: 'bg-success/10 text-success', dot: 'bg-success', icon: CheckCircle },
  cancelled: { label: 'Cancelled', color: 'bg-destructive/10 text-destructive', dot: 'bg-destructive', icon: XCircle },
}

/** E4 (SA-389, spec D26): the commerce ladder — mirrors the backend's
 * `COMMERCE_LADDER_STATUSES` (moves INTO these 404 without `commerce`). */
export const COMMERCE_LADDER_STATUSES: ReadonlySet<OrderStatus> = new Set([
  'pending_payment', 'deposit_paid', 'fully_paid', 'in_production', 'ready', 'delivered',
])
